import styled from './styles';

export { default } from './Icon';

export const StyledIcon = styled.Svg;
